import type {TableConfiguration} from 'schema/table/types';
import type {BulkUpdateSummary} from 'services/bulkUpdates/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';

export const bulkUpdateSummaryTableConfig: TableConfiguration<BulkUpdateSummary> =
  {
    ...defaultTableConfig,
    disableSorting: true,
  };
